import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; 
import './styles/index.scss'; 
import App from './App';
import store from './store/store';
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from 'react-redux';

let persistore = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistore} loading={null}>
      <App />
    </PersistGate>
  </Provider>
);
